module.exports = __webpack_public_path__ + "img/logo.ac0e4306.png";